<div class="container-md p-md-0">
  <tds-notifications
    [notifications]="order_notifications"
    [notification_type]="storage_key"
    (mark_as_read)="markNotificationAsRead($event)"
  />

  <div
    ts-page-title
    [navigation_title]="navigation_title"
    [page_title]="page_title"
    [bg]="true"
    [sticky]="true"
    [nav_content]="navContent"
    [@routerAnimation]="o && o.isActivated && o.activatedRoute"
    (@routerAnimation.start)="onRouterAnimationStart($event)"
  >
    <router-outlet #o="outlet" />
  </div>
</div>

<ng-template #navContent>
  <div class="bg-highlight">
    <div class="container-fluid">
      <div class="container-md p-0 py-3">
        <div class="row">
          <ts-progress-bar />
        </div>
      </div>
    </div>

    <ts-ofo-indicator />
  </div>
</ng-template>
